(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const figures = [...root.querySelectorAll('[data-figure-index]')];
    if (!figures.length) return;
    const dots = [...root.querySelectorAll('[data-select]')];
    const title = root.querySelector('[data-carousel-title]');
    const link = root.querySelector('[data-carousel-link]');
    const cta = root.querySelector('[data-carousel-cta-text]');
    const status = root.querySelector('[data-carousel-status]');
    const stage = root.querySelector('.gm-figure-carousel__stage');
    let current = Number(root.dataset.initial) || 0;
    let pointer = null;
    let suppressClickUntil = 0;
    const mobile = matchMedia('(max-width:700px)');
    function select(index, announce = true) {
      current = (index + figures.length) % figures.length;
      figures.forEach((figure, i) => {
        let offset = (i - current + figures.length) % figures.length;
        if (offset > figures.length / 2) offset -= figures.length;
        const visible = Math.abs(offset) <= (mobile.matches ? 1 : 2);
        figure.dataset.position = Math.abs(offset) <= 2 ? String(offset) : 'hidden';
        figure.tabIndex = visible ? 0 : -1;
        figure.setAttribute('aria-pressed', String(i === current));
        figure.setAttribute('aria-hidden', String(!visible));
      });
      dots.forEach((dot, i) => i === current ? dot.setAttribute('aria-current','true') : dot.removeAttribute('aria-current'));
      title.textContent = figures[current].dataset.title;
      link.href = figures[current].dataset.url;
      cta.textContent = figures[current].dataset.cta;
      if (announce) status.textContent = `${figures[current].dataset.title}, ${current + 1} of ${figures.length}`;
      root.dataset.activeIndex = String(current);
    }
    root.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (Date.now() < suppressClickUntil) { event.preventDefault(); return; }
      if (button.hasAttribute('data-direction')) select(current + Number(button.dataset.direction));
      else if (button.hasAttribute('data-figure-index')) select(Number(button.dataset.figureIndex));
      else if (button.hasAttribute('data-select')) select(Number(button.dataset.select));
    });
    root.addEventListener('keydown', event => {
      const actions = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: figures.length - 1 };
      if (!(event.key in actions)) return;
      event.preventDefault();select(actions[event.key]);
      if (event.target.matches('[data-figure-index]')) figures[current].focus({preventScroll:true});
    });
    stage.addEventListener('pointerdown', event => { if (event.button === 0) pointer = {x:event.clientX,y:event.clientY,id:event.pointerId}; });
    stage.addEventListener('pointerup', event => {
      if (!pointer || pointer.id !== event.pointerId) return;
      const dx=event.clientX-pointer.x, dy=event.clientY-pointer.y;pointer=null;
      if (Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.3) {select(current+(dx<0?1:-1));suppressClickUntil=Date.now()+400;}
    });
    stage.addEventListener('pointercancel',()=>{pointer=null;});
    stage.addEventListener('dragstart',event=>event.preventDefault());
    mobile.addEventListener('change',()=>select(current,false));
    root.classList.add('is-enhanced');select(current,false);
    document.addEventListener('shopify:block:select', event => {
      const figure = event.target.closest?.('[data-figure-index]');
      if (figure && root.contains(figure)) select(Number(figure.dataset.figureIndex));
    });
  }
  document.querySelectorAll('[data-figure-carousel]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-figure-carousel]').forEach(init));
})();
